import { Button, TextInput } from "@tremor/react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { resetPassword } from "../api/auth.js";

import { useTranslation } from "react-i18next";

function getToken() {
  return new URLSearchParams(window.location.search).get("token") || "";
}

export default function ResetPassword() {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);

    if (!getToken()) {
      setError(t("reset_password.error_token"));
      return;
    }

    if (!password || password !== confirmPassword) {
      setError(t("reset_password.error_match"));
      return;
    }

    setLoading(true);
    try {
      await resetPassword(getToken(), password);
      setSuccess(true);
      setTimeout(() => navigate("/login", { replace: true }), 1200);
    } catch (err) {
      setError(err.response?.data?.error ?? "Could not reset password.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-sm rounded-lg bg-white p-8 shadow">
        <h1 className="mb-2 text-center text-2xl font-bold text-gray-900">
          {t("reset_password.title")}
        </h1>
        <p className="mb-6 text-center text-sm text-gray-500">
          {t("reset_password.subtitle")}
        </p>

        {success ? (
          <p className="rounded-md bg-green-50 px-3 py-2 text-sm text-green-700">
            {t("reset_password.success")}
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">{t("reset_password.new_password")}</label>
              <TextInput
                type="password"
                required
                value={password}
                onValueChange={setPassword}
                className="mt-1"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">{t("reset_password.confirm_password")}</label>
              <TextInput
                type="password"
                required
                value={confirmPassword}
                onValueChange={setConfirmPassword}
                className="mt-1"
              />
            </div>

            {error && (
              <p className="rounded-md bg-red-50 px-3 py-2 text-sm text-red-600">{error}</p>
            )}

            <Button type="submit" disabled={loading} className="w-full">
              {loading ? t("reset_password.updating") : t("reset_password.submit")}
            </Button>
          </form>
        )}

        <div className="mt-6 text-center text-sm">
          <Link to="/login" className="text-teal-600 hover:text-teal-700">
            {t("reset_password.back_to_login")}
          </Link>
        </div>
      </div>
    </div>
  );
}
